import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-xl pt-[16px] pb-[32px] px-[24px] w-[391px] bg-theme-grey" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["type"]
const _hoisted_5 = { class: "absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 z-30" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "mt-3 w-full text-center cursor-pointer font-medium text-theme-green text-[14px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Base = _resolveComponent("Base")!

  return (_openBlock(), _createBlock(_component_Base, null, {
    basecontent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "hello mt-5 text-white text-center text-lg" }, "Hello! :)", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"])),
          ref: "loginform",
          autocomplete: "off"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.loginForm.email.error_type))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "mt-3 mb-1 block label-text text-white" }, " Email ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline",
              name: "email",
              role: "presentation",
              autocomplete: "off",
              placeholder: "Your email",
              rules: 'required',
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.email.value) = $event)),
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateFields(['email'])))
            }, null, 544), [
              [_vModelText, _ctx.loginForm.email.value]
            ]),
            (_ctx.loginForm.email.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.loginForm.email.error_message)
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.loginForm.password.error_type))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "mt-3 mb-1 block label-text text-white" }, " Password ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                name: "password",
                type: _ctx.showpassword ? 'text' : 'password',
                class: "shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline",
                placeholder: "Your password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.password.value) = $event)),
                autocomplete: "off",
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['password'])))
              }, null, 40, _hoisted_4), [
                [_vModelDynamic, _ctx.loginForm.password.value]
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_EyeIcon, {
                  class: _normalizeClass([{'hidden': !_ctx.showpassword, 'block':_ctx.showpassword }, "text-white w-5"]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showpassword = !_ctx.showpassword))
                }, null, 8, ["class"]),
                _createVNode(_component_EyeOffIcon, {
                  class: _normalizeClass([{'block': !_ctx.showpassword, 'hidden':_ctx.showpassword }, "text-white w-5"]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showpassword = !_ctx.showpassword))
                }, null, 8, ["class"])
              ])
            ]),
            (_ctx.loginForm.password.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.loginForm.password.error_message)
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: {
                name: 'ForgotPassword'
              } }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" FORGOT PASSWORD? ", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("button", {
            type: "submit",
            class: "mt-8 bg-theme-green hover:bg-theme-darkgreen rounded w-[100%] text-[14px] text-bold text-white p-[8px]"
          }, " SIGN IN ", -1))
        ], 544)
      ])
    ]),
    _: 1
  }))
}